import { Button, Form, Input, Select, Space } from "antd";
import { useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import SelectDownIcon from "../../../assets/icons/SelectDownIcon";
import CustomCard from "../../../components/common/CustomCard";
import Loader from "../../../components/ui/Loader";
import {
  useAssignProjectMutation,
  useGetSingleCompanyQuery,
} from "../../../features/portal/companyOnboard/companyOnboardApi";
import { useGetAllProductQuery } from "../../../features/portal/Products/productsApi";
import useError from "../../../hooks/useError";
import SidebarLayout from "../../../layouts/SidebarLayout";
import { toast } from "../../../lib/toast";

export default function BusinessProductAssign() {
  const { id } = useParams();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const backLink = "/admin/businesses/business-list";

  const { isError, error, isLoading, data } = useGetSingleCompanyQuery(
    id || "",
    {
      skip: !id,
    }
  );
  const {
    isError: isAllProductError,
    error: allProductError,
    data: getAllProduct,
  } = useGetAllProductQuery({
    params: {
      page: 1,
      limit: 1000,
    },
  });
  const [
    assignProject,
    {
      isLoading: assignProjectIsLoading,
      isError: assignProjectIsError,
      error: assignProjectError,
      isSuccess: assignProjectIsSuccess,
    },
  ] = useAssignProjectMutation();

  useError(isAllProductError, allProductError, "Get all product fail");
  useError(isError, error, "Get single company fail");
  useError(
    assignProjectIsError,
    assignProjectError,
    "Company product assigned fail"
  );

  const allProduct = getAllProduct?.data?.data;
  const detailsData = data?.data;

  const onFinish = (values: any) => {
    const newData = {
      companyId: Number(id),
      projectId: Number(values?.projectId),
    };

    assignProject(newData);
  };

  useEffect(() => {
    if (detailsData) {
      form.setFieldsValue({
        company_name: detailsData?.company_name,
      });
    }
  }, [detailsData, form]);

  useEffect(() => {
    if (assignProjectIsSuccess) {
      toast("success", "Company product assigned successfully");
      navigate(backLink);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assignProjectIsSuccess]);

  return (
    <SidebarLayout title={"Assign Product"} backLink={backLink}>
      {isLoading ? (
        <Loader />
      ) : (
        <Form
          className="custom-form"
          layout="vertical"
          // requiredMark="optional"
          size="large"
          onFinish={onFinish}
          form={form}
          initialValues={{
            company_name: detailsData?.company_name,
          }}
        >
          <CustomCard className="grid grid-cols-3 gap-6 p-6  rounded-b-none">
            <Form.Item
              label="Company Name"
              name="company_name"
              rules={[{ required: true, message: "Please enter company name" }]}
            >
              <Input placeholder="Enter Company name" disabled />
            </Form.Item>

            <Form.Item
              label="Select Product"
              name="projectId"
              rules={[{ required: true, message: "Please select product" }]}
            >
              <Select
                placeholder="Select Product"
                options={allProduct?.map((project: any) => ({
                  label: project?.name,
                  value: project?.id,
                }))}
                // onChange={(value) => setSelectedProjectId(value)}
                className="w-full"
                suffixIcon={<SelectDownIcon />}
                style={{ width: "100%" }}
                allowClear
                showSearch
                optionFilterProp="label"
              />
            </Form.Item>
          </CustomCard>
          <div className="p-6 rounded-md rounded-t-none bg-white border border-t-0 border-light">
            <Space className="w-full mt-2" size={12}>
              <Link to={backLink}>
                <Button
                  className="normal-dark-button modal-button"
                  size="middle"
                >
                  Cancel
                </Button>
              </Link>
              <Button
                className="modal-button"
                type="primary"
                htmlType="submit"
                size="middle"
                loading={assignProjectIsLoading}
              >
                Save
              </Button>
            </Space>
          </div>
        </Form>
      )}
    </SidebarLayout>
  );
}
